module.exports = __webpack_public_path__ + "img/All Rounder Locked.666eda5.png";